import React from "react";
import { connect } from "react-redux";
import ModuleLoader from "../../components/ModuleLoader";

const mstp = ({ authentication, logout }) => ({ authentication, logout });

const App = () => {
  return (
    <ModuleLoader />
  );
};

export default connect(mstp)(App);
